import { useMemo } from "react";

import { EntityId } from "@reduxjs/toolkit";

import { Box, Chip } from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";

import { useAppSelector } from "app/hooks";
import { RootState } from "app/store";
import { playbackDebugSelectors } from "./store/selectors.debug";
import { playbackSessionSelectors } from "./store/selectors.session";
import { selectDeviceByIdFactory } from "features/devices/store/selectors";

import { PlaybackDeviceDebugStatistics } from "./PlaybackDeviceDebugStatistics";
import { RecordingPlayer } from "./RecordingPlayer";

export interface PlaybackDeviceProps {
    sessionId: string;
    siteId: EntityId;
    deviceId: EntityId;
}

export function PlaybackDevice(props: PlaybackDeviceProps) {
    // get recordings for this device from store
    const selectRecordingsByDeviceId = useMemo(
        () => playbackSessionSelectors.selectRecordingsByDeviceIdFactory(),
        [],
    );
    const deviceRecordings = useAppSelector((state: RootState) =>
        selectRecordingsByDeviceId(state, props.deviceId),
    );

    const showStatistics = useAppSelector(
        playbackDebugSelectors.selectShowStatistics,
    );

    const playbackStartDateTime = useAppSelector(
        playbackSessionSelectors.selectPlaybackStartDateTime,
    );

    const selectDeviceById = useMemo(() => selectDeviceByIdFactory(), []);
    const device = useAppSelector((state) =>
        selectDeviceById(state, props.deviceId.toString()),
    );

    return (
        <Box>
            <Chip
                sx={{ width: "100%", marginBottom: 2 }}
                color="secondary"
                icon={<VideocamIcon />}
                label={device?.name}
            />
            {showStatistics && (
                <PlaybackDeviceDebugStatistics deviceId={props.deviceId} />
            )}
            {device &&
                deviceRecordings &&
                deviceRecordings.map((recording) => (
                    <RecordingPlayer
                        key={recording.id}
                        sessionId={props.sessionId}
                        siteId={props.siteId}
                        recordingId={recording.id}
                        originalStartTime={recording.originalStartTime}
                        deviceId={recording.deviceId}
                        deviceName={device.name}
                        playbackStartDateTime={playbackStartDateTime}
                    />
                ))}
        </Box>
    );
}
